import './grid.scss';

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Row = forwardRef(({ className, noGutters, children, ...props }, ref) => (
  <div
    ref={ref}
    className={classNames({
      row: true,
      'no-gutters': noGutters,
      [className]: className,
    })}
    {...props}
  >
    {children}
  </div>
));

Row.propTypes = {
  className: PropTypes.string,
  noGutters: PropTypes.bool,
  children: PropTypes.node,
};

Row.defaultProps = {
  noGutters: false,
};

const Col = forwardRef((props, ref) => {
  const className = classNames({
    [`col-${props.xs}`]: props.xs,
    [`col-sm-${props.sm}`]: props.sm,
    [`col-md-${props.md}`]: props.md,
    [`col-lg-${props.lg}`]: props.lg,
    [`col-xl-${props.xl}`]: props.xl,
    [props.className]: props.className,
  });

  return (
    <div ref={ref} className={className}>
      {props.children}
    </div>
  );
});

Col.propTypes = {
  xs: PropTypes.number,
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
  xl: PropTypes.number,
  className: PropTypes.string,
  children: PropTypes.node,
};

const Grid = { Row, Col };

export default Grid;
